import React, { FC } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import MembersTable from '../MembersTable';
import useSellSideActions from '../../hooks/useSellSideActions';
import useMembers from '../../../../hooks/useMembers';

import './SellSideMobile.styles.scss';

type SellSideMobileProps = {
  onlyNew?: boolean;
};

const SellSideMobile: FC<SellSideMobileProps> = ({ onlyNew = false }) => {
  const { t } = useTranslation();

  const { sellSideMembers } = useMembers(onlyNew);

  const classes = classNames('sell-side-mobile');

  const { RenderAddMemberDrawer, actionButton } = useSellSideActions();

  return (
    <div className={classes}>
      <div className="heading">
        <p>{t('sellSide')}</p>
        {!onlyNew && actionButton}
      </div>

      <MembersTable className="white-panel" members={sellSideMembers} />

      {RenderAddMemberDrawer}
    </div>
  );
};

export default SellSideMobile;
